<div class="dfu-wrapper" [class.dfu-wrapper-inline]="renderMode === 'expanded'">
  @if (renderMode === 'pill') {
    <div class="dfu-content dfu-content-disabled" aria-hidden="true">
      <ng-content></ng-content>
    </div>
  }

  @if (renderMode === 'pill') {
    <button
      type="button"
      class="dfu-pill"
      [class.dfu-pill-inline]="pillMode === 'relative'"
      [class.dfu-pill-open]="isOpen"
      [attr.data-pos]="pillPosition"
      (click)="toggleOpen()"
      [attr.aria-label]="(isOpen ? 'Close' : 'Open') + ' disabled details for ' + title"
      >
      <span class="dfu-pill-text">{{ badgeText }}</span>
    </button>
  }

  @if (renderMode === 'expanded') {
    <div class="dfu-card dfu-card-inline">
      <ng-container [ngTemplateOutlet]="cardBodyTpl" [ngTemplateOutletContext]="{ canClose: false }"></ng-container>
    </div>
  } @else {
    @if (isOpen) {
      <div class="dfu-overlay" role="dialog" aria-modal="true">
        <div class="dfu-card" (click)="$event.stopPropagation()">
          <ng-container [ngTemplateOutlet]="cardBodyTpl" [ngTemplateOutletContext]="{ canClose: true }"></ng-container>
        </div>
        <div class="dfu-backdrop" (click)="close()"></div>
      </div>
    }
  }


  <ng-template #cardBodyTpl let-canClose="canClose">
    <div class="dfu-card-top">
      <div class="dfu-badge">{{ badgeText }}</div>
      @if (canClose) {
        <button type="button" class="dfu-close" (click)="close()" aria-label="Close">
          ✕
        </button>
      }
    </div>

    <div class="dfu-header">
      @if (title) {
        <div class="dfu-title">{{ title }}</div>
      }
      <div class="dfu-desc">{{ description }}</div>
    </div>

    @if (learnMoreHref) {
      <a
        class="dfu-learn"
        [href]="learnMoreHref"
        target="_blank"
        rel="noopener"
        >
        {{ learnMoreLabel }}
      </a>
    }
  </ng-template>
</div>
